(function () {
  // Global flag so you can confirm the file is loaded
  window.__showOrderLoaded = true;
  console.log("[show_order] loaded");

  const BTN_SELECTOR = "#showCreateDraftBtn";

  // TODO: set these
  const BACKEND_ENDPOINT = "https://deals.loveinfaith.life/show/create_draft_and_log";
  const INTERNAL_TOKEN = "38dkdv983m9e99kancik3e4m59423f3r3";

  async function getCart() {
    console.log("[show_order] fetching /cart.js");
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("Could not read cart (/cart.js failed).");
    const cart = await res.json();
    console.log("[show_order] cart items:", cart.items?.length || 0);
    return cart;
  }

  async function sendToBackend(email, cart) {
    const items = (cart.items || []).map((it) => ({
      variant_id: it.variant_id,
      quantity: it.quantity,
      title: it.product_title,
    }));

    const payload = { email, items, internal_token: INTERNAL_TOKEN };


    console.log("[show_order] POST", BACKEND_ENDPOINT, payload);

    const res = await fetch(BACKEND_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    const text = await res.text(); // read raw first for better errors
    let data = {};
    try { data = text ? JSON.parse(text) : {}; } catch (e) {}

    console.log("[show_order] response status:", res.status, data);

    if (!res.ok) {
      const detail = data?.detail ? JSON.stringify(data.detail) : text || "Request failed";
      throw new Error(detail);
    }

    return data;
  }

  function setBusy(btn, busy) {
    if (!btn) return;
    if (busy) {
      btn.disabled = true;
      btn.dataset.oldText = btn.textContent;
      btn.textContent = "Saving...";
    } else {
      btn.disabled = false;
      if (btn.dataset.oldText) btn.textContent = btn.dataset.oldText;
    }
  }

  async function clearCart() {
    console.log("[show_order] clearing cart");
    const res = await fetch("/cart/clear.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin"
    });
    if (!res.ok) throw new Error("Could not clear cart.");
  }

  async function handleClick(btn) {
    try {
      console.log("[show_order] click");

      const cart = await getCart();
      if (!cart.items || cart.items.length === 0) {
        alert("Cart is empty.");
        return;
      }

      const email = window.__wholesaleCustomerEmail;
      if (!email) {
        alert("You must be signed in to save an order.");
        return;
      }

      setBusy(btn, true);
      const result = await sendToBackend(email, cart);

      let msg = "Saved!\n";
      if (result.draft_order_name) msg += `Draft: ${result.draft_order_name}\n`;
      if (result.cart_link) msg += `Cart link saved.\n`;
      if (result.sheet_row) msg += `Sheet row: ${result.sheet_row}\n`;
      alert(msg);

      const shouldClear = window.confirm("Clear your cart now?");
      if (shouldClear) {
        await clearCart();
        window.location.reload();
      }

    } catch (err) {
      console.error("[show_order] error:", err);
      alert("Error: " + (err?.message || "Unknown error"));
    } finally {
      setBusy(btn, false);
    }
  }

  // Event delegation so it still works after Trade updates the cart DOM
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(BTN_SELECTOR);
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    handleClick(btn);
  });
})();
